// Brand tokens for the landing page — maps to CSS vars in index.css (spec-* namespace)
// Use Tailwind classes (e.g. text-spec-brown, bg-spec-cream) whenever possible.
// These constants are for inline styles only where Tailwind doesn't reach (e.g. gradients with rgba).

export const C = {
  cream: "#FAF8F3",
  warm: "#EDE9E0",
  parch: "#E3DDD2",
  white: "#FFFFFF",
  sage: "#6B7D56",
  sageMuted: "#8B9E76",
  sageGlow: "rgba(107,125,86,0.10)",
  sageBdr: "rgba(107,125,86,0.22)",
  gold: "#966F2C",
  goldGlow: "rgba(150,111,44,0.10)",
  goldBdr: "rgba(150,111,44,0.25)",
  brown: "#5C4A2F",
  txt: "#3D3225",
  txt2: "#604F34",
  txt3: "#726658",
  bdr: "rgba(139,115,85,0.18)",
  shadow: "0 1px 3px rgba(61,50,37,0.08), 0 1px 2px rgba(61,50,37,0.05)",
  shadowMd: "0 4px 16px rgba(61,50,37,0.12)",
  shadowLg: "0 12px 48px rgba(61,50,37,0.18)",
  purple: "#6A5878",
  purpleGlow: "rgba(106,88,120,0.10)",
  purpleBdr: "rgba(106,88,120,0.22)",
} as const;

export const F = {
  d: "'Cormorant Garamond', Georgia, serif",
  u: "'Jost', 'Segoe UI', sans-serif",
} as const;
